<template>
  <div class="w-full h-full" style="background: #1a3a0a;">
    <router-view v-slot="{ Component }">
      <keep-alive :include="appStore.includeList">
        <component :is="Component" />
      </keep-alive>
    </router-view>
    
    <template>
      <CheckInVfm :show="checkInvfm" @onclose="checkInvfm = false" @onsuccess="getCheckIn" :list="checkInDays"
        :data="checkInData" />
      <BonusCodeVfm :show="bonusCodeVfm" @onclose="bonusCodeVfm = false" />

    </template>

    <Coin :value="coinValue" ref="coinRef" />
  </div>
</template>

<script setup>
import eventBus from "@/utils/eventBus";

import { useAppStore } from "./stores/modules/app";
import { useUserStore } from "./stores/modules/user";
import { useLayoutStore } from "./stores/modules/layout";
import PcLoginVfm from "@/components/vfm/pc/Login.vue";
import PcSettingVfm from "@/components/vfm/pc/Setting.vue";
import PcCheckInVfm from "@/components/vfm/pc/CheckIn.vue";
import PcSearchVfm from "@/components/vfm/pc/Search.vue";
import PcBonusCodeVfm from "@/components/vfm/pc/BonusCode.vue";
import BonusCodeVfm from "@/components/vfm/phone/BonusCode.vue";

import CheckInVfm from "@/components/vfm/phone/CheckIn.vue";

import { computed } from "vue";
import { wsClient } from '@/utils/websocket'
import { useRouter } from "vue-router";

const appStore = useAppStore();
const userStore = useUserStore();
const layoutStore = useLayoutStore();
const router = useRouter();
const startX = ref(0);
const startY = ref(0);
const pcLoginVfm = ref(false); //pc登录vfm
const pcLoginType = ref("in"); //pc登录type in up
const pcSettingVfm = ref(false); //pc进入游戏前校验账号vfm
const pcCheckInvfm = ref(false); //pc签到vfm
const pcSearchVfm = ref(false); //pc搜素vfm
const pcBonusCodeVfm = ref(false); //活动兑换奖励code码
const bonusCodeVfm = ref(false); //活动兑换奖励code码

const coinValue = ref(0); //领取金币金额
const coinRef = ref(); //领取金币dom
const checkInvfm = ref(false); //手机签到vfm

const isMobile = computed(() => {
  // console.log('window.innerWidth=========',window.innerWidth)
  // console.log('isMobile手机？？？？？？？？？',layoutStore.isMobile)
  return layoutStore.isMobile;
});
const checkInData = computed(() => {
  return userStore.checkInData;
});
const checkInDays = computed(() => {
  return userStore.checkInDays;
});
onMounted(async () => {
  appLoading(); //初始化加载loading
  document.addEventListener("touchstart", handleTouchStart, { passive: false });
  document.addEventListener("touchmove", handleTouchMove, { passive: false });
  appStore.getConfig(); //获取app配置信息
  appStore.getLocaltionUrlParse(); //获取地址栏域名
  appStore.getDeviceId(); //获取设备码
  appStore.getMenuList(); //获取左侧菜单列表
  // appStore.getMfrList(); //获取厂商列表
  // appStore.getSortList(); //获取分类栏目
  userStore.getVipLevelList(); //获取vip等级
  appStore.initLangs(); //初始化语言
  userStore.checkToken(); //校验token
  appStore.getDepositType(); //获取充值方式
  // userStore.getCheckIn();
  wsClient.connect();

  eventBus.on("Login", type => {
    router.push({ path: "/login", query: { type: type || "in" } });
  });
  eventBus.on("changeLogin", () => {
    router.push("/login");
  });
  eventBus.on("Logout", () => {
    router.push("/home");
    // userStore.getVipLevelList();
    // userStore.getCheckIn();
  });
  // pc端
  // if (!isMobile.value) {
    // eventBus.on("Login", type => {
    //   pcLoginVfm.value = true;
    //   pcLoginType.value = type;
    // });
  //   eventBus.on("PcSettingAccount", () => {
  //     pcSettingVfm.value = true;
  //   });

  //   eventBus.on("PcSearch", () => {
  //     pcSearchVfm.value = true;
  //   });
  // }
  eventBus.on("BonusCode", () => {
    console.log('xxxxxxxxxxxxxxxxxxxxx', isMobile.value)
    // isMobile.value ? bonusCodeVfm.value = true : pcBonusCodeVfm.value = true
    bonusCodeVfm.value = true
  });
  eventBus.on("CheckIn", () => {
    // isMobile.value ? checkInvfm.value = true : pcCheckInvfm.value = true
    checkInvfm.value = true;
  });
  eventBus.on("ShowCoin", e => {
    coinValue.value = Number(e);
    coinRef.value.showCoin();
  });
  eventBus.on('kick_user', () => {
    console.log("接收到踢出用户的通知");
    router.push("/"); // 使用 router 进行导航
  });
});
onUnmounted(() => {
  wsClient.disconnect();
  document.removeEventListener("touchstart", handleTouchStart);
  document.removeEventListener("touchmove", handleTouchMove);
  // if (!isMobile.value) {
    // eventBus.off("Login");
  //   eventBus.off("PcSettingAccount");
  //   eventBus.off("PcSearch");
  // }
  eventBus.off("Login");
  eventBus.off("changeLogin");
  eventBus.off("Logout");
  eventBus.off("CheckIn");
  eventBus.off("BonusCode");
  eventBus.off("ShowCoin");
  eventBus.off("kick_user");
});

function handleChangePcLoginType(e) {
  pcLoginType.value = e;
}
function appLoading() {
  const loadingEle = document.getElementById("app-loading");
  loadingEle.style.display = "block";
  loadingEle.style.background = "var(--bg-color-1)";
  setTimeout(() => {
    loadingEle.style.display = "none";
    loadingEle.style.background = "";
  }, 500);
}

const handleTouchStart = event => {
  if (event.touches.length === 1) {
    startX.value = event.touches[0].clientX;
    startY.value = event.touches[0].clientY;
  }
};

const handleTouchMove = event => {
  if (event.touches.length === 1) {
    const deltaX = event.touches[0].clientX - startX.value;
    const deltaY = event.touches[0].clientY - startY.value;

    // 如果水平移动大于垂直移动，则阻止默认行为
    if (Math.abs(deltaX) > Math.abs(deltaY)) {
      event.preventDefault();
    }
  }
};
const getCheckIn = () => {
  userStore.getCheckIn();
};
</script>
<script>
export default {
  mounted() {

    let script = document.createElement('script')
    script.src = 'https://plugin-code.salesmartly.com/js/project_240300_247092_1739196782.js'
    script.onload = () => {

      let timer = setInterval(() => {

        if (window.ssq) {

          clearInterval(timer)

          let user = JSON.parse(localStorage.getItem('userinfo') || '{}')

          if (user.id) {

            window.ssq.push('setLoginInfo', {
              user_id: String(user.id),
              user_name: user.username || ('user_' + user.id),
              description: '网站用户ID：' + user.id
            })

            console.log('客服用户绑定成功')
          }
        }

      },300)
    }

    document.body.appendChild(script)
  }
}
</script>
<style lang="scss">
@import "@/assets/css/common.scss";
@import "@/assets/css/aliicon.css";
html {
  max-width: 540px; 
  margin: auto !important;

  background-image: none;
}
body {
    overflow-x: hidden;
}
.page-container {

  min-height: 80vh;
  // padding-top: calc(55px + var(--app-download-height, 0px) + var(--app-header-tab-height, 0px));
}

.page-container.hide-top {
  padding-top: 0;
}

.page-pb-tabbar {
  padding-bottom: var(--app-tabbar-height);
}

.pc-header {
  height: var(--pc-header-height);
}

.wrap {
  margin: 0 auto;
  max-width: 1414px;
  min-width: 720px;
  padding-left: 32px;
  padding-right: 32px;
  width: 100%;
}

.page-pc {
  padding-top: var(--pc-header-height);
}

// @media (max-width: 767px) {

//   html,
//   body {
//     scrollbar-width: none;
//     /* 针对 Firefox */
//   }

//   html::-webkit-scrollbar {
//     display: none;
//     /* 针对 WebKit 浏览器（Chrome, Safari 等） */
//   }
// }

// @media (min-width: 768px) {

//   html,
//   body {
//     // overflow-y: auto;
//     scrollbar-width: none;
//     /* 针对 Firefox */
//   }

//   html::-webkit-scrollbar {
//     display: none;
//     /* 针对 WebKit 浏览器（Chrome, Safari 等） */
//   }
// }
</style>
